<template>
  <div class="mx-auto max-w-md pt-20 text-center">
    <span class="loading loading-spinner loading-lg"></span>
    <p class="text-base-content/60 mt-4">Logging in…</p>
  </div>
</template>
